<template>
  <div>
    <div class="col-md-12" style="padding-left: 5%; padding-right: 5%;">
      <div class="bg-plans-form mt-10">
        <h2>
          จัดการข้อมูลติดต่อ
        </h2>
        <br />
        <b-button variant="success" @click="contactActionModal()">+ เพิ่มผู้ติดต่อ</b-button>
        <table ref="table_1" id="table_1" class="display" style="width:100%">
        </table>

      </div>
    </div>
    <b-modal id="contactCreateForm" ref="contactActionModal" centered no-enforce-focus size="lg" title="เพิ่มผู้ติดต่อ">
      <label class="mr-sm-2">ชื่อผู้ติดต่อ</label>
      <b-form-input v-model="contactCreateForm.contactName" size="sm"></b-form-input>

      <label class="mr-sm-2 mt-3">เบอร์โทร</label>
      <b-form-input v-model="contactCreateForm.contactPhone" size="sm" type="number"></b-form-input>

      <label class="mr-sm-2 mt-3">อีเมล</label>
      <b-form-input v-model="contactCreateForm.contactEmail" size="sm"></b-form-input>

      <label class="mr-sm-2 mt-3">บริษัท</label>
          <b-form-select id="contactCreateForm_companyData" class="plans-form-select-lg custom-select2"
            v-model="contactCreateForm.companyData" :options="formSetting.companyData"></b-form-select>

      <template #modal-footer="{ cancel }">
        <b-button variant="primary" @click="confirmActioncontact()">
          ยืนยีน
        </b-button>
        <b-button variant="danger" @click="cancel()">
          ยกเลิก
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import FetchService from "@/core/services/fetch.service";
import DataTable from 'datatables.net-bs4';
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
import 'datatables.net-rowgroup-bs4';
import 'datatables.net-rowgroup-bs4/css/rowGroup.bootstrap4.css';
import 'datatables.net-buttons-bs4';
import 'datatables.net-buttons-bs4/css/buttons.bootstrap4.css';
import $ from "jquery";
import moment from "moment";
import Swal from 'sweetalert2'
export default {
  data() {
    return {
      masterDataTable: {},
      dataTable: [],
      masterData: [],
      masterFormData: {
        companyData: []
      },
      contactCreateForm: {
        contactName: "",
        contactPhone: "",
        contactEmail: "",
        companyData: ""
      },
      contactEditMode: 0,
      contactIdSelect: "",
      formSetting: {
        contactName: "",
        contactPhone: "",
        contactEmail: "",
        companyData: ""
      },
    };
  },
  mounted() {
    this.getCompanyData()
    setTimeout(() => {
      this.getDataTable()
    }, 100)
  },
  methods: {
    getDataTable() {
      if (this.masterDataTable?.destroy) {
        this.masterDataTable.destroy()
      }
      FetchService.get("/getcontact", (response) => {
        if (response) {
          response = JSON.parse(response)
          this.masterData = response.thisContact
          this.pageInit()
        }
      })
    },
    getCompanyData() {
      FetchService.get("/getcompany", (response) => {
        if (response) {
          response = JSON.parse(response)
          this.masterFormData.companyData = response.allCompany
          this.formSetting.companyData = response.allCompany.map(e => {
            return {
              value: e._id,
              text: e.name
            }
          })
        }
      })
    },
    pageInit() {

      let that = this

      let arrTable = this.masterData.map((row, index) => {

        let findCompany
        if(row?.company_id) {
          findCompany = this.masterFormData.companyData.find(e => { 
            return (row.company_id == e._id || row.company_id == e.name) || (e.taxId && row.taxId == e.taxId)
          })
        }

        console.log("findCompany", findCompany)

        return [
          row?._id ? row._id : "",
          row?.name ? row.name : "",
          row?.phoneNumber ? row.phoneNumber : "",
          row?.email ? row.email : "",
          findCompany?.name ? findCompany.name : "",
          `<button type="button" class="btn btn-warning mr-4 btn-edit" style="cursor: pointer" value="${row?._id}">แก้ไข</button> <button type="button" class="btn btn-danger mr-4 btn-del" style="cursor: pointer" value="${row?._id}">ลบ</button>`,
        ]
      })

      this.masterDataTable = new DataTable('#table_1', {
        data: arrTable,
        columns: [
          { title: 'ID' },
          { title: 'ชื่อผู้ติดต่อ' },
          { title: 'โทรศัพท์' },
          { title: 'อีเมล' },
          { title: 'บริษัท' },
          { title: 'ดำเนินการ' }
        ],
        dom: 'Bfrtip'
      });

      $('#table_1').on('click', '.btn-edit', (event) => {
        var data = event.currentTarget.value
        that.actionEditcontact(data)
      });

      $('#table_1').on('click', '.btn-del', (event) => {
        var data = event.currentTarget.value
        that.actionDelcontact(data)
      });

    },
    actionEditcontact(contactId) {
      this.contactActionModal()

      const rowData = this.findMasterDataById(contactId)
      this.contactCreateForm = {
        contactName: rowData.name,
        contactPhone: rowData.phoneNumber,
        contactEmail: rowData.email,
        companyData: rowData.company_id
      }

      this.contactEditMode = 1
      this.contactIdSelect = contactId

    },
    actionDelcontact(contactId) {
      console.log("delcontact", contactId)
      this.contactIdSelect = contactId
      Swal.fire({
        title: 'ยืนยันการลบ ?',
        text: "คุณยืนยันการลบผู้ติดต่อ ใช่หรือไม่",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3699FE',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          this.delcontact()
        }
      })
    },
    findMasterDataById(id) {
      return this.masterData.find(e => {
        return e._id === id
      })
    },
    contactActionModal() {
      this.clearForm()
      this.$refs["contactActionModal"].show();
      setTimeout(() => {
        $('.custom-select2').select2({
          theme: 'bootstrap4',
        });
      }, 100)
    },
    addcontact() {

      let set = $('#contactCreateForm_companyData').val()

      var raw = JSON.stringify({
        "contactName": this.contactCreateForm.contactName,
        "contactPhone": this.contactCreateForm.contactPhone,
        "contactEmail": this.contactCreateForm.contactEmail,
      });

      FetchService.post("/addcontact/" + set , raw, res => {
        console.log(res)

        Swal.fire(
          'สำเร็จ',
          'บันทึกข้อมูลแล้ว',
          'success'
        )

        this.getDataTable()
        this.$refs["contactActionModal"].hide()
      })

    },
    editcontact() {

      var raw = JSON.stringify({
        "contactName": this.contactCreateForm.contactName,
        "contactPhone": this.contactCreateForm.contactPhone,
        "contactEmail": this.contactCreateForm.contactEmail,
        "companyId": $('#contactCreateForm_companyData').val()
      });

      FetchService.post(`/editcontact/${this.contactIdSelect}`, raw, res => {
        Swal.fire(
          'สำเร็จ',
          'แก้ไขข้อมูลแล้ว',
          'success'
        )
        this.getDataTable()
        this.$refs["contactActionModal"].hide()
      })
    },
    delcontact() {
      FetchService.get(`/deletecontact/${this.contactIdSelect}`, res => {
        console.log(res)

        Swal.fire(
          'สำเร็จ',
          'ลบข้อมูลแล้ว',
          'success'
        )

        this.getDataTable()
        this.$refs["contactActionModal"].hide()
      })
    },
    clearForm() {
      this.contactCreateForm = {
        contactName: "",
        contactPhone: "",
        contactEmail: "",
      }
      this.contactEditMode = 0
    },
    confirmActioncontact() {
      if (this.contactCreateForm.contactName == "") {
        Swal.fire(
          'มีข้อผิดพลาด',
          'กรุณาระบุชื่อผู้ติดต่อ',
          'error'
        )
      } else {
        if (this.contactEditMode === 1) {
          Swal.fire({
            title: 'ยืนยันการแก้ไข ?',
            text: "คุณยืนยันการแก้ไขผู้ติดต่อ ใช่หรือไม่",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3699FE',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก'
          }).then((result) => {
            if (result.isConfirmed) {
              this.editcontact()
            }
          })
        } else {
          Swal.fire({
            title: 'ยืนยันการบันทึก ?',
            text: "คุณยืนยันการบันทึกผู้ติดต่อ ใช่หรือไม่",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3699FE',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก'
          }).then((result) => {
            if (result.isConfirmed) {
              this.addcontact()
            }
          })
        }
      }
    }
  }
};

</script>

<style>
.bg-plans-form {
  background-color: #FFFFFF;
  border-radius: 10px;
  padding: 20px;
  font-size: 1rem;
  font-weight: 500;
}

input,
label {
  margin: 0.5rem 0;
}

#table_1 table {
  border-collapse: separate;
  border-spacing: 0;
}

#table_1 th {
  border: solid 1px #DEDFE0;
  border-style: none solid solid none;
  padding: 10px;
}

.dataTables_wrapper .dataTable thead th {
  border-top: solid 1px #DEDFE0;
  background-color: #f9fafb;
}


#table_1 thead tr:first-child th:first-child {
  border-top-left-radius: 10px;
}

#table_1 thead tr:first-child th:last-child {
  border-top-right-radius: 10px;
}

#table_1 thead tr:first-child th {
  border-top-style: solid;
}

#table_1 thead tr th:first-child {
  border-left-style: solid;
}

#table_1 td {
  border: solid 1px #DEDFE0;
  border-style: none solid solid none;
  padding: 10px;
}

#table_1 tbody th {
  border-style: none solid solid solid;
}

#table_1 tbody tr:first-child td:first-child {
  /* border-top-left-radius: 10px; */
}

#table_1 tbody tr:first-child td:last-child {
  /* border-top-right-radius: 10px; */
}

#table_1 tbody tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}

#table_1 tbody tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}

#table_1 tbody tr:first-child td {
  border-top-style: solid;
}

#table_1 tbody tr td:first-child {
  border-left-style: solid;
}

#table_1 tbody tr:first-child td:first-child.dataTables_empty {
  border-top-left-radius: 0px;
}

#table_1 tbody tr:first-child td:last-child.dataTables_empty {
  border-top-right-radius: 0px;
}

table.dataTable thead .sorting:before,
table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_desc:before {
  content: "" !important;
}

table.dataTable thead .sorting:after {
  content: "" !important;
}

table.dataTable thead .sorting_asc:after {
  content: "▲" !important;
  content: "▲" /"" !important;
}

table.dataTable thead .sorting_desc:after {
  content: "▼" !important;
  content: "▼" /"" !important;
}

table.dataTable tr.dtrg-group th {
  background-color: #f2f2f2;
  text-align: left;
}

#table_1 tbody tr:hover {
  background-color: #f5f5f5;
  /* สีที่คุณต้องการเมื่อ hover */
  cursor: pointer;
}

.dt-search {
  text-align: right;
  padding-bottom: 0.85rem;
}

.dt-search {
  text-align: right;
}
</style>